import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { SegurosContratadosEntity } from "../datosGenerales/entities/seguros_contratados_entity";
import { SegurosContratadosService } from "./seguros-contratados.service";
import { correctHeight, detectBody } from "../../../app.helpers";
import { VehiculoEntity } from "../datosGenerales/entities/vehiculo_entity";
import { DatosGeneralesService } from "../datosGenerales/datos-generales.service";
import { ClienteIndividualEntity } from "../datosGenerales/entities/datos_generales_individual_entity";
import { ConsultarUsuarioMasivos } from "../../../components/common/utils/consultarUsuarioMasivos";
import { ViviendaEntity } from "../datosGenerales/entities/vivienda_entity";
import { UtilService } from "../../../components/common/utils/util.service";
import { AsistenciaMedicaEntity } from "../datosGenerales/entities/asistencia_medica_entity";
import { BeneficiariosAsistenciaMedicaEntity } from "../datosGenerales/entities/beneficiarios_asistencia_medica_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ProductosGeneralesEntity } from "../datosGenerales/entities/productos_generales_entity";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { BienSolicitudEntity } from "../datosGenerales/entities/bien_asegurado_entity";
import { RelacionBeneficiario } from "../datosGenerales/entities/relacion_beneficiario";
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { RenovacionService } from "../renovaciones/renovacion.service";
import { DetalleAsistenciaMedica } from "../datosGenerales/entities/detalle_asistencia_medica";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";
import { CoberturaBienEntity } from "../datosGenerales/entities/coberturas_entity";
import { VidaEntity } from '../datosGenerales/entities/vida_entity';



const swal = require("sweetalert2");


declare var jQuery: any;
@Component({
  selector: 'segurosContratados',
  providers: [SegurosContratadosService],
  templateUrl: 'seguros-contratados.template.html',
  styleUrls: ["seguros-contratados.style.css"]


})
export class SegurosContratados extends CalendarFechaNac implements OnInit {
  usuario: ClienteLogin;
  segurosContratados: SegurosContratadosEntity;
  beneficiariosLista: BeneficiariosAsistenciaMedicaEntity[];
  clienteMasivosIndividual: ClienteIndividualEntity;

  vehiculoReporteSiniestro: VehiculoEntity;
  viviendaReporteSiniestro: ViviendaEntity;
  vamReporteSiniestro: AsistenciaMedicaEntity;

  @ViewChild('dependientes')
  modal: ModalComponent;

  @ViewChild('coberturas')
  modalCob: ModalComponent;
  renovarVehiculo: boolean;
  rutaCancelacion: boolean;
  rutaRenovacion: boolean;
  renovarOtroRamo: boolean;
  renovarAsistencia: boolean;
  renovarvivienda: boolean;
  cancelarBien: boolean;
  beneficiariosBandera: boolean;
  nuevoDependienteBandera: boolean;
  usuarioLogin: UsuarioLoginEntity;
  reporteVeh: boolean = false;
  reporteViv: boolean = false;
  reporteVam: boolean = false;
  Accion: number

  veh: boolean;
  viv: boolean;
  asi: boolean;
  pro: boolean;
  vid: boolean;
  RELACIONES: RelacionBeneficiario[] = [
    { Codigo: 1, Descripcion: 'Conyuge' },
    { Codigo: 2, Descripcion: 'Hijo' },
    { Codigo: 3, Descripcion: 'Hija' }
  ];
  nuevoBeneficiario: BeneficiariosAsistenciaMedicaEntity;
  beneficiariosNuevos: BeneficiariosAsistenciaMedicaEntity[];
  asistenciaMedicaModificado: DetalleAsistenciaMedica;
  asistenciaMedicaActual: DetalleAsistenciaMedica;
  asistencia: AsistenciaMedicaEntity;

  @SessionStorage("VehiculoSeleccionado")
  public vehiculoSelect;
  @SessionStorage("ViviendaSeleccionada")
  public viviendaSelect;
  @SessionStorage("AsistenciaMedicaSeleccionada")
  public AsistenciaSelect;
  @SessionStorage("OtrosRamosSeleccionado")
  public otrosRamosSelect;
  @SessionStorage("BienSeleccionado")
  public bienAseguradoSelect;
  coberturasBien: CoberturaBienEntity[];
  deduciblesBien: CoberturaBienEntity[];
  beneficiosBien: CoberturaBienEntity[];
  carenciasBien: CoberturaBienEntity[];
  exclusionesBien: CoberturaBienEntity[];
  clausulasBien: CoberturaBienEntity[];
  aclaratorioBien: CoberturaBienEntity[];
  bandera: boolean;
  cob: boolean;
  ded: boolean;
  ben: boolean;
  car: boolean;
  exc: boolean;
  cla: boolean;
  acl: boolean;

  //0=sin leyenda, 1=solo por renovar, 2=solo por cancelar, 3=por renovar y cancelar
  leyendaVeh: number;
  porRenVeh: number = 0;
  porCanVeh: number = 0;

  leyendaViv: number;
  porRenViv: number = 0;
  porCanViv: number = 0;

  leyendaGrl: number;
  porRenGrl: number = 0;
  porCanGrl: number = 0;

  leyendaAsi: number;
  porRenAsi: number = 0;
  porCanAsi: number = 0;

  urlOrigen: string = "";
  urlAsesor: string = "";
  banderaCita: boolean = false;

  @ViewChild('agendarCita')
  modalAsesor: ModalComponent;

  presentarAsesor: boolean = false;
  constructor(private segurosContratadosService: SegurosContratadosService,
    public utilsService: UtilService,
    private renovacionService: RenovacionService,
    private router: Router,
    private sessionTokenService: SessionTokenService,
    private handleError: HandleError,
    private datosGeneralesIndividualSevice: DatosGeneralesService,
    private consultarMasivo: ConsultarUsuarioMasivos,
    private sesionStorageService: SessionStorageService) {
    super();
    this.renovarVehiculo = false;
    this.renovarOtroRamo = false;
    this.renovarAsistencia = false;
    this.renovarvivienda = false;
    this.cancelarBien = false;
    this.veh = false;
    this.viv = false;
    this.asi = false;
    this.pro = false;
    this.vid = false;
    this.bandera = false;
    this.cob = false;
    this.ded = false;
    this.ben = false;
    this.car = false;
    this.exc = false;
    this.cla = false;
    this.acl = false;
    this.segurosContratados = new SegurosContratadosEntity();
    this.segurosContratados.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
    this.segurosContratados.ProductosGenerales = new Array<ProductosGeneralesEntity>();
    this.segurosContratados.SegurosVehiculo = new Array<VehiculoEntity>();
    this.segurosContratados.SegurosVivienda = new Array<ViviendaEntity>();
    this.segurosContratados.Vida = new Array<VidaEntity>();
  }

  OpcionesChangeVehiculo(vehiculoEntity: VehiculoEntity, accion: number) {
    this.renovarVehiculo = false;
    this.cancelarBien = false;
    this.segurosContratados.SegurosVehiculo.filter(function (el) {
      if (el.CodVehiculo !== vehiculoEntity.CodVehiculo)
        el.Accion = 0;
    });
    if (accion != 0 && accion == 2) {
      this.vehiculoSelect = JSON.stringify(vehiculoEntity);
      this.renovarVehiculo = true;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 1) {
      this.GenerarPdfVehiculo(vehiculoEntity);
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false;
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 3) {
      let bienSolicitudEntity = new BienSolicitudEntity();
      bienSolicitudEntity.CodigoCliente = vehiculoEntity.CodCliente;
      bienSolicitudEntity.CodigoCiudadTecni = vehiculoEntity.CiuCod;
      bienSolicitudEntity.CodigoProducto = vehiculoEntity.CodProducto;
      bienSolicitudEntity.CodigoBienAsegurado = vehiculoEntity.CodVehiculo;
      bienSolicitudEntity.TipoCobertura = 0;
      bienSolicitudEntity.TipoSolicitud = 2;
      bienSolicitudEntity.NombreProducto = vehiculoEntity.NombreProducto;
      this.bienAseguradoSelect = JSON.stringify(bienSolicitudEntity);
      this.cancelarBien = true;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false;
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 9) {
      this.vehiculoReporteSiniestro = vehiculoEntity;
      this.cancelarBien = false;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = true;
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion == 0) {
      this.cancelarBien = false;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false;
      this.reporteViv = false;
      this.reporteVam=false;
    }
  }

  OpcionesChangeVivienda(viviendaEntity: ViviendaEntity, accion: number) {
    this.renovarvivienda = false;
    this.cancelarBien = false;
    this.segurosContratados.SegurosVivienda.filter(function (el) {
      if (el.CodVivienda !== viviendaEntity.CodVivienda)
        el.Accion = 0;
    });
    if (accion != 0 && accion == 2) {
      this.viviendaSelect = JSON.stringify(viviendaEntity);
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = true;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 1) {
      this.GenerarPdfVivienda(viviendaEntity);
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 3) {
      let bienSolicitudEntity = new BienSolicitudEntity();
      bienSolicitudEntity.CodigoCliente = viviendaEntity.CodCliente;
      bienSolicitudEntity.CodigoCiudadTecni = viviendaEntity.CiuCod;
      bienSolicitudEntity.CodigoProducto = viviendaEntity.CodProducto;
      bienSolicitudEntity.CodigoBienAsegurado = viviendaEntity.CodVivienda;
      bienSolicitudEntity.TipoCobertura = viviendaEntity.CodTipoEstructura;
      bienSolicitudEntity.TipoSolicitud = 2;
      bienSolicitudEntity.NombreProducto = viviendaEntity.NombreProducto;
      this.bienAseguradoSelect = JSON.stringify(bienSolicitudEntity);
      this.cancelarBien = true;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 10) {
      this.viviendaReporteSiniestro = viviendaEntity;
      this.cancelarBien = false;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false
      this.reporteViv = true;
      this.reporteVam=false;
    }
  }

  OpcionesChangeAsistenciaMedica(asistenciaMedicaEntity: AsistenciaMedicaEntity, accion: number) {
    this.renovarVehiculo = false;
    this.cancelarBien = false;
    this.segurosContratados.AsistenciaMedica.filter(function (el) {
      if (el.CodAccPer !== asistenciaMedicaEntity.CodAccPer)
        el.Accion = 0;
    });
    if (accion != 0 && accion == 2) {
      this.AsistenciaSelect = JSON.stringify(asistenciaMedicaEntity);
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = true;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 5) {
      this.ObtenerDependientes(asistenciaMedicaEntity);
      this.asistencia = this.cloneAsistenciaMedicaEntity(asistenciaMedicaEntity);
      this.modal.open();
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 3) {
      let bienSolicitudEntity = new BienSolicitudEntity();
      bienSolicitudEntity.CodigoCliente = asistenciaMedicaEntity.CodCliente;
      bienSolicitudEntity.CodigoCiudadTecni = asistenciaMedicaEntity.CiuCod;
      bienSolicitudEntity.CodigoProducto = asistenciaMedicaEntity.CodProducto;
      bienSolicitudEntity.CodigoBienAsegurado = asistenciaMedicaEntity.CodAccPer;
      bienSolicitudEntity.TipoCobertura = 0;
      bienSolicitudEntity.TipoSolicitud = 2;
      bienSolicitudEntity.NombreProducto = asistenciaMedicaEntity.NombreProducto;
      this.bienAseguradoSelect = JSON.stringify(bienSolicitudEntity);
      this.cancelarBien = true;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }
    if (accion != 0 && accion == 6) {
      this.CargarCoberturas(asistenciaMedicaEntity);
      this.modalCob.open();
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=false;
    }

    if (accion != 0 && accion == 11) {
      this.vamReporteSiniestro = asistenciaMedicaEntity;
      this.cancelarBien = false;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.reporteVeh = false
      this.reporteViv = false;
      this.reporteVam=true;
    }

  }
  OpcionesChangeOtrosRamos(otrosRamosEntity: ProductosGeneralesEntity, accion: number) {
    this.renovarVehiculo = false;
    this.cancelarBien = false;
    this.segurosContratados.ProductosGenerales.filter(function (el) {
      if (el.CodProdGnral !== otrosRamosEntity.CodProdGnral)
        el.Accion = 0;
    });
    if (accion != 0 && accion == 2) {
      this.otrosRamosSelect = JSON.stringify(otrosRamosEntity)
      this.renovarVehiculo = false;
      this.renovarOtroRamo = true;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
      this.cancelarBien = false;
    }
    if (accion != 0 && accion == 3) {
      let bienSolicitudEntity = new BienSolicitudEntity();
      bienSolicitudEntity.CodigoCliente = otrosRamosEntity.CodCliente;
      bienSolicitudEntity.CodigoCiudadTecni = otrosRamosEntity.CiuCod;
      bienSolicitudEntity.CodigoProducto = otrosRamosEntity.CodProducto;
      bienSolicitudEntity.CodigoBienAsegurado = otrosRamosEntity.CodProdGnral;
      bienSolicitudEntity.TipoCobertura = 0;
      bienSolicitudEntity.TipoSolicitud = 2;
      bienSolicitudEntity.NombreProducto = otrosRamosEntity.NombreProducto;
      this.bienAseguradoSelect = JSON.stringify(bienSolicitudEntity);
      this.cancelarBien = true;
      this.renovarVehiculo = false;
      this.renovarOtroRamo = false;
      this.renovarAsistencia = false;
      this.renovarvivienda = false;
    }
  }
  GenerarPdfVehiculo(vehiculoEntity: VehiculoEntity) {
    this.segurosContratadosService.getCertificadoVehiculos(vehiculoEntity).subscribe(result => {
      let fileBlob = result.blob();
      let blob = new Blob([fileBlob], {
        type: 'application/pdf'
      });
      var a = document.createElement("a");

      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "certificadoVehiculo" + ".pdf";
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, "certificado" + ".pdf");
      }
      else {
        a.click();
        window.URL.revokeObjectURL(url);
      }
      swal({
        title: 'Certificado de Vehículo',
        text: "Su certificado se abrirá en una ventana alterna, verifique que no se encuentran bloqueadas las ventanas emergentes en su navegador",
        type: 'success'
      })
    }, error => this.handleError.redirectUrl(error));
  }
  GenerarPdfVivienda(viviendaEntity: ViviendaEntity) {
    this.segurosContratadosService.getCertificadoVivienda(viviendaEntity).subscribe(result => {
      let fileBlob = result.blob();
      let blob = new Blob([fileBlob], {
        type: 'application/pdf'
      });

      var a = document.createElement("a");

      let url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "certificadoVivienda" + ".pdf";
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, "certificado" + ".pdf");
      }
      else {
        a.click();
        window.URL.revokeObjectURL(url);
      }

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
      }
      else {
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      }

      swal({
        title: 'Certificado de vivienda',
        text: "Su certificado se abrirá en una ventana alterna, verifique que no se encuentran bloqueadas las ventanas emergentes en su navegador",
        type: 'success'
      })
    }, error => this.handleError.redirectUrl(error));
  }
  ObtenerDependientes(asistenciaMedicaEntity: AsistenciaMedicaEntity) {
    this.utilsService.getDependientes(asistenciaMedicaEntity).subscribe(beneficiarios => {
      this.beneficiariosLista = beneficiarios
    },
      error => { this.handleError.redirectUrl(error); });
  }
  segurosContratadosPorRenovar(segurosContratadosEntity: SegurosContratadosEntity): SegurosContratadosEntity {
    let segurosContratadosRenovar = new SegurosContratadosEntity();

    if (segurosContratadosEntity != undefined) {
      let o;
      if (segurosContratadosEntity.SegurosVehiculo != undefined && segurosContratadosEntity.SegurosVehiculo != null && segurosContratadosEntity.SegurosVehiculo.length > 0) {
        segurosContratadosRenovar.SegurosVehiculo = new Array<VehiculoEntity>();
        o = segurosContratadosRenovar.SegurosVehiculo;
        segurosContratadosEntity.SegurosVehiculo.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 2 || a.Codigo == 8) {
              el.Renovar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosRenovar.SegurosVehiculo = new Array<VehiculoEntity>();
      }
      if (segurosContratadosEntity.SegurosVivienda != undefined && segurosContratadosEntity.SegurosVivienda != null && segurosContratadosEntity.SegurosVivienda.length > 0) {
        segurosContratadosRenovar.SegurosVivienda = new Array<ViviendaEntity>();
        o = segurosContratadosRenovar.SegurosVivienda;
        segurosContratadosEntity.SegurosVivienda.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 2 || a.Codigo == 8) {
              el.Renovar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosRenovar.SegurosVivienda = new Array<ViviendaEntity>();
      }
      if (segurosContratadosEntity.AsistenciaMedica != undefined && segurosContratadosEntity.AsistenciaMedica != null && segurosContratadosEntity.AsistenciaMedica.length > 0) {
        segurosContratadosRenovar.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
        o = segurosContratadosRenovar.AsistenciaMedica;
        segurosContratadosEntity.AsistenciaMedica.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 2 || a.Codigo == 8) {
              el.Renovar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosRenovar.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
      }
      if (segurosContratadosEntity.ProductosGenerales != undefined && segurosContratadosEntity.ProductosGenerales != null && segurosContratadosEntity.ProductosGenerales.length > 0) {
        segurosContratadosRenovar.ProductosGenerales = new Array<ProductosGeneralesEntity>();
        o = segurosContratadosRenovar.ProductosGenerales;
        segurosContratadosEntity.ProductosGenerales.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 2 || a.Codigo == 8) {
              el.Renovar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosRenovar.ProductosGenerales = new Array<ProductosGeneralesEntity>();
      }
      segurosContratadosRenovar.Vida = new Array<VidaEntity>();
      return segurosContratadosRenovar;
    }
  }
  segurosContratadosPorCancelar(segurosContratadosEntity: SegurosContratadosEntity): SegurosContratadosEntity {
    let segurosContratadosCancelar = new SegurosContratadosEntity();

    if (segurosContratadosEntity != undefined) {
      let o;
      if (segurosContratadosEntity.SegurosVehiculo != undefined && segurosContratadosEntity.SegurosVehiculo != null && segurosContratadosEntity.SegurosVehiculo.length > 0) {
        segurosContratadosCancelar.SegurosVehiculo = new Array<VehiculoEntity>();
        o = segurosContratadosCancelar.SegurosVehiculo;
        segurosContratadosEntity.SegurosVehiculo.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 3 || a.Codigo == 7) {
              el.Cancelar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosCancelar.SegurosVehiculo = new Array<VehiculoEntity>();
      }
      if (segurosContratadosEntity.SegurosVivienda != undefined && segurosContratadosEntity.SegurosVivienda != null && segurosContratadosEntity.SegurosVivienda.length > 0) {
        segurosContratadosCancelar.SegurosVivienda = new Array<ViviendaEntity>();
        o = segurosContratadosCancelar.SegurosVivienda;
        segurosContratadosEntity.SegurosVivienda.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 3 || a.Codigo == 7) {
              el.Cancelar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosCancelar.SegurosVivienda = new Array<ViviendaEntity>();
      }
      if (segurosContratadosEntity.AsistenciaMedica != undefined && segurosContratadosEntity.AsistenciaMedica != null && segurosContratadosEntity.AsistenciaMedica.length > 0) {
        segurosContratadosCancelar.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
        o = segurosContratadosCancelar.AsistenciaMedica;
        segurosContratadosEntity.AsistenciaMedica.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 3 || a.Codigo == 7) {
              el.Cancelar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosCancelar.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
      }
      if (segurosContratadosEntity.ProductosGenerales != undefined && segurosContratadosEntity.ProductosGenerales != null && segurosContratadosEntity.ProductosGenerales.length > 0) {
        segurosContratadosCancelar.ProductosGenerales = new Array<ProductosGeneralesEntity>();
        o = segurosContratadosCancelar.ProductosGenerales;
        segurosContratadosEntity.ProductosGenerales.filter(function (el) {
          el.Opciones.forEach(a => {
            if (a.Codigo == 3 || a.Codigo == 7) {
              el.Cancelar = a.Codigo;
              o.push(el);
            }
          })
        });
      } else {
        segurosContratadosCancelar.ProductosGenerales = new Array<ProductosGeneralesEntity>();
      }
      segurosContratadosCancelar.Vida = new Array<VidaEntity>();
      return segurosContratadosCancelar;
    }
  }

  set dateSBeneficiario(e) {
    this.nuevoBeneficiario.FechaNacimiento = new Date(e);
  }

  get dateSBeneficiario() {
    if (this.nuevoBeneficiario.FechaNacimiento != undefined) {
      try {
        var a = this.nuevoBeneficiario.FechaNacimiento.toISOString().substring(0, 10);
        var b = a.split("-");
        return b[2] + "/" + b[1] + "/" + b[0];
      } catch (e) {
        var a = this.nuevoBeneficiario.FechaNacimiento.toString().substring(0, 10);
        var b = a.split("-");
        return b[2] + "/" + b[1] + "/" + b[0];
      }
    }
  }
  nuevoDependiente() {
    this.nuevoDependienteBandera = true;
  }

  incluirNuevoBeneficiario() {
    this.beneficiariosBandera = true;
    let codigo = this.nuevoBeneficiario;
    let valor = this.RELACIONES.find(function (el) {
      return el.Codigo == codigo.CodRelacion;
    });
    if (this.nuevoBeneficiario.Codigo == undefined) {
      let date = new Date();
      this.nuevoBeneficiario.Relacion = valor.Descripcion;
      this.nuevoBeneficiario.Codigo = date.getMilliseconds() + date.getFullYear();
      this.beneficiariosNuevos.push(this.nuevoBeneficiario);
    } else {
      this.beneficiariosNuevos.forEach(function (e1) {
        if (e1.Codigo == codigo.Codigo) {
          e1.Nombre = codigo.Nombre;
          e1.ApellidoMaterno = codigo.ApellidoMaterno;
          e1.ApellidoPaterno = codigo.ApellidoPaterno;
          e1.FechaNacimiento = codigo.FechaNacimiento;
          e1.Relacion = valor.Descripcion;
        }
      });
    }
    this.nuevoBeneficiario = new BeneficiariosAsistenciaMedicaEntity();

  }

  eliminarBeneficiarioNuevo(beneficiarioNuevo: BeneficiariosAsistenciaMedicaEntity) {
    this.beneficiariosNuevos = this.beneficiariosNuevos.filter(function (el) { return el.Codigo !== beneficiarioNuevo.Codigo; });
  }

  cloneAsistenciaMedica(c: DetalleAsistenciaMedica) {
    let asistencia = new DetalleAsistenciaMedica();
    for (let prop in c) {
      asistencia[prop] = c[prop];
    }
    return asistencia;
  }
  cloneAsistenciaMedicaEntity(c: AsistenciaMedicaEntity) {
    let asistenciaEntity = new AsistenciaMedicaEntity();
    for (let prop in c) {
      asistenciaEntity[prop] = c[prop];
    }
    return asistenciaEntity;
  }

  solicitarInclusionDependientes() {
    this.renovacionService.datosAsistenciaMedica(this.asistencia).subscribe(
      asistenciaMedica => {
        this.asistenciaMedicaModificado = this.cloneAsistenciaMedica(asistenciaMedica);
        this.asistenciaMedicaModificado.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
        this.asistenciaMedicaActual = asistenciaMedica;
        this.asistenciaMedicaActual.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;
        this.asistenciaMedicaModificado.BeneficiariosNuevos = this.beneficiariosNuevos;
        this.segurosContratadosService.insertarDependientesInclusion(this.asistenciaMedicaModificado).subscribe(
          result => {
            if (result) {
              this.modal.close();
              swal({
                title: 'Inclusión dependientes',
                text: "Recuerde que los datos seran verificados por un ejecutivo, para hacer efectiva la(s) inclusiones",
                type: 'success'
              }).then(function () {
                window.location.reload(true);
              });
            } else {
              this.modal.close();
              swal({
                title: 'Inclusión',
                text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                type: 'warning'
              }).then(function () {
                this.router.navigate(["/error/500"]);
              });
            }
          },
          error => { this.handleError.redirectUrl(error); }
        );
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }

  ngOnInit(): void {
    try {
      this.coberturasBien = new Array<CoberturaBienEntity>();
      this.deduciblesBien = new Array<CoberturaBienEntity>();
      this.beneficiosBien = new Array<CoberturaBienEntity>();
      this.carenciasBien = new Array<CoberturaBienEntity>();
      this.exclusionesBien = new Array<CoberturaBienEntity>();
      this.clausulasBien = new Array<CoberturaBienEntity>();
      this.aclaratorioBien = new Array<CoberturaBienEntity>();

      let hoy = new Date();
      let fechaSalida = new Date();
      fechaSalida.setFullYear(2020);
      fechaSalida.setMonth(6);
      fechaSalida.setDate(3);
      if(hoy >= fechaSalida){//cambio del asesor virtual visible desde el 03 de agosto del 2020 eliminar esta validación después de esa fecha :)
        this.presentarAsesor = true;
      }
      /*correctHeight();
      detectBody();*/
      this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
      if (this.usuario == null) {
        let error = { "status": 998, "message": "Acceso denegado" };
        this.handleError.redirectUrl(error)
      } else {
        let bandera = this.sessionTokenService.useJwtHelper();
        if (!bandera) {
          this.beneficiariosBandera = false;
          this.segurosContratados = new SegurosContratadosEntity();
          this.asistenciaMedicaModificado = new DetalleAsistenciaMedica();
          this.nuevoBeneficiario = new BeneficiariosAsistenciaMedicaEntity();
          this.beneficiariosNuevos = new Array<BeneficiariosAsistenciaMedicaEntity>();
          this.consultarMasivo.iniciarUsuarioMasivo();
          this.datosGeneralesIndividualSevice.datosClienteIndividual().subscribe(
            datosClienteIndividual => {
              this.clienteMasivosIndividual = datosClienteIndividual;
              this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno));
              sessionStorage.setItem("NombreUser", this.clienteMasivosIndividual.Nombres + " " + this.clienteMasivosIndividual.ApellidoPaterno + " " + this.clienteMasivosIndividual.ApellidoMaterno);
            },
            error => { this.handleError.redirectUrl(error); });

          this.segurosContratados = new SegurosContratadosEntity();
          this.segurosContratados.AsistenciaMedica = new Array<AsistenciaMedicaEntity>();
          this.segurosContratados.ProductosGenerales = new Array<ProductosGeneralesEntity>();
          this.segurosContratados.SegurosVehiculo = new Array<VehiculoEntity>();
          this.segurosContratados.SegurosVivienda = new Array<ViviendaEntity>();
          this.segurosContratados.Vida = new Array<VidaEntity>();

          this.segurosContratadosService.consultaSegurosContratados().subscribe(segurosContratados => {
            this.segurosContratados = this.cloneSegurosContratados(segurosContratados);
            this.rutaCancelacion = this.router.isActive('/masivos/servicios/cancelacion-bienAsegurado', false);
            this.rutaRenovacion = this.router.isActive('/masivos/servicios/renovacion-bienAsegurado', false);
            if (this.rutaCancelacion) {
              this.segurosContratados = this.segurosContratadosPorCancelar(this.cloneSegurosContratados(this.segurosContratados));
            } else {
              if (this.rutaRenovacion) {
                this.segurosContratados = this.segurosContratadosPorRenovar(this.cloneSegurosContratados(this.segurosContratados));
              } else {
                this.segurosContratados.SegurosVehiculo.forEach(a => {

                  if (a.EstadoSolicitud == 8)
                    this.porRenVeh += 1;
                  else if (a.EstadoSolicitud == 7)
                    this.porCanVeh += 1;

                  a.Opciones = a.Opciones.filter(function (item) {
                    if (item.Codigo !== 8)
                      if (item.Codigo !== 7)
                        return item;
                  });
                });

                if (this.porRenVeh > 0 && this.porCanVeh > 0)
                  this.leyendaVeh = 3;
                else if (this.porRenVeh == 0 && this.porCanVeh == 0)
                  this.leyendaVeh = 0;
                else if (this.porRenVeh > 0 && this.porCanVeh == 0)
                  this.leyendaVeh = 1;
                else if (this.porRenVeh == 0 && this.porCanVeh > 0)
                  this.leyendaVeh = 2;

                this.segurosContratados.SegurosVivienda.forEach(a => {

                  if (a.EstadoSolicitud == 8)
                    this.porRenViv += 1;
                  else if (a.EstadoSolicitud == 7)
                    this.porCanViv += 1;

                  a.Opciones = a.Opciones.filter(function (item) {
                    if (item.Codigo !== 8)
                      if (item.Codigo !== 7)
                        return item;
                  });
                });

                if (this.porRenViv > 0 && this.porCanViv > 0)
                  this.leyendaViv = 3;
                else if (this.porRenViv == 0 && this.porCanViv == 0)
                  this.leyendaViv = 0;
                else if (this.porRenViv > 0 && this.porCanViv == 0)
                  this.leyendaViv = 1;
                else if (this.porRenViv == 0 && this.porCanViv > 0)
                  this.leyendaViv = 2;

                this.segurosContratados.AsistenciaMedica.forEach(a => {

                  if (a.EstadoSolicitud == 8)
                    this.porRenAsi += 1;
                  else if (a.EstadoSolicitud == 7)
                    this.porCanAsi += 1;

                  a.Opciones = a.Opciones.filter(function (item) {
                    if (item.Codigo !== 8)
                      if (item.Codigo !== 7)
                        return item;
                  });
                });

                if (this.porRenAsi > 0 && this.porCanAsi > 0)
                  this.leyendaAsi = 3;
                else if (this.porRenAsi == 0 && this.porCanAsi == 0)
                  this.leyendaAsi = 0;
                else if (this.porRenAsi > 0 && this.porCanAsi == 0)
                  this.leyendaAsi = 1;
                else if (this.porRenAsi == 0 && this.porCanAsi > 0)
                  this.leyendaAsi = 2;

                this.segurosContratados.ProductosGenerales.forEach(a => {

                  if (a.EstadoSolicitud == 8)
                    this.porRenGrl += 1;
                  else if (a.EstadoSolicitud == 7)
                    this.porCanGrl += 1;

                  a.Opciones = a.Opciones.filter(function (item) {
                    if (item.Codigo !== 8)
                      if (item.Codigo !== 7)
                        return item;
                  });
                });

                if (this.porRenGrl > 0 && this.porCanGrl > 0)
                  this.leyendaGrl = 3;
                else if (this.porRenGrl == 0 && this.porCanGrl == 0)
                  this.leyendaGrl = 0;
                else if (this.porRenGrl > 0 && this.porCanGrl == 0)
                  this.leyendaGrl = 1;
                else if (this.porRenGrl == 0 && this.porCanGrl > 0)
                  this.leyendaGrl = 2;

              }
            }
            this.getStyle();


          }, error => this.handleError.redirectUrl(error));
        }
      }
    } catch (ex) {
      this.usuarioLogin = jQuery.parseJSON(sessionStorage.getItem("usuarioLogin"));
      let bandera = this.usuarioLogin.Tipo;
      this.router.navigate(["/login", bandera]);
    }
  }

  cloneSegurosContratados(c: SegurosContratadosEntity) {
    let seguros = new SegurosContratadosEntity();
    for (let prop in c) {
      seguros[prop] = c[prop];
    }
    return seguros;
  }

  ocultarTabs(): void {

    if (this.coberturasBien != null && this.coberturasBien.length > 0) {
      this.cob = true;
      this.ded = false;
      this.ben = false;
      this.car = false;
      this.exc = false;
      this.cla = false;
      this.acl = false;
    }
    if (this.deduciblesBien != null && this.deduciblesBien.length > 0) {
      this.cob = false;
      this.ded = true;
      this.ben = false;
      this.car = false;
      this.exc = false;
      this.cla = false;
      this.acl = false;
    }
    if (this.beneficiosBien != null && this.beneficiosBien.length > 0) {
      this.cob = false;
      this.ded = false;
      this.ben = true;
      this.car = false;
      this.exc = false;
      this.cla = false;
      this.acl = false;
    }
    if (this.carenciasBien != null && this.carenciasBien.length > 0) {
      this.cob = false;
      this.ded = false;
      this.ben = false;
      this.car = true;
      this.exc = false;
      this.cla = false;
      this.acl = false;
    }
    if (this.exclusionesBien != null && this.exclusionesBien.length > 0) {
      this.cob = false;
      this.ded = false;
      this.ben = false;
      this.car = false;
      this.exc = true;
      this.cla = false;
      this.acl = false;
    }
    if (this.clausulasBien != null && this.clausulasBien.length > 0) {
      this.cob = false;
      this.ded = false;
      this.ben = false;
      this.car = false;
      this.exc = false;
      this.cla = true;
      this.acl = false;
    }
    if (this.aclaratorioBien != null && this.aclaratorioBien.length > 0) {
      this.cob = false;
      this.ded = false;
      this.ben = false;
      this.car = false;
      this.exc = false;
      this.cla = false;
      this.acl = true;
    }
  }

  getStyle(): void {
    if (this.segurosContratados.SegurosVehiculo != null && this.segurosContratados.SegurosVehiculo.length > 0) {
      this.veh = true;
      this.vid = false;
      this.asi = false;
      this.pro = false;
      this.viv = false;
    } else {
      if (this.segurosContratados.SegurosVivienda != null && this.segurosContratados.SegurosVivienda.length > 0) {
        this.veh = false;
        this.vid = false;
        this.asi = false;
        this.pro = false;
        this.viv = true;
      } else {
        if (this.segurosContratados.AsistenciaMedica != null && this.segurosContratados.AsistenciaMedica.length > 0) {
          this.veh = false;
          this.vid = false;
          this.asi = true;
          this.pro = false;
          this.viv = false;
        } else {
          if (this.segurosContratados.Vida != null && this.segurosContratados.Vida.length > 0) {
            this.veh = false;
            this.vid = true;
            this.asi = false;
            this.pro = false;
            this.viv = false;
          } else {
            if (this.segurosContratados.ProductosGenerales != null && this.segurosContratados.ProductosGenerales.length > 0) {
              this.veh = false;
              this.vid = false;
              this.asi = false;
              this.pro = true;
              this.viv = false;
            }
          }
        }
      }
    }
  }

  CargarCoberturas(asistenciaMedicaEntity: AsistenciaMedicaEntity) {

    if (this.bandera == false) {
      this.segurosContratadosService.traerCoberturas(asistenciaMedicaEntity).subscribe(coberturas => {
        this.bandera = true;
        coberturas.forEach(element => {

          switch (element.TipoCobertura) {
            case 1:
              this.coberturasBien.push(element);
              this.cob = true;
              break;
            case 2:
              this.deduciblesBien.push(element);
              break;
            case 3:
              this.beneficiosBien.push(element);
              break;
            case 4:
              this.carenciasBien.push(element);
              break;
            case 5:
              this.exclusionesBien.push(element);
              break;
            case 6:
              this.clausulasBien.push(element);
              break;
            case 7:
              this.aclaratorioBien.push(element);
              break;
          }

        });

      }
        ,
        error => { this.handleError.redirectUrl(error); });
    }
  }

  CargarAsesor(bandera: number, poliza?: any) {
    var bandTipoProceso = 5;
    if (this.rutaCancelacion == true) {
      bandTipoProceso = 4;
    }
    if (this.rutaRenovacion == true) {
      bandTipoProceso = 2;
    }
    let ban = 0;

    switch (bandera) {
      case 1:
      case 2:
        ban = 1;
        break
      case 3:
      case 4:
      case 5:
        ban = 2
        break;
    }

    this.utilsService.getUriAsesorVirtual(ban).subscribe(
      resultUri => {
        this.urlOrigen = resultUri;
        switch (bandera) {
          case 1: //vehiculos
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/1/1/"+poliza.CodVehiculo+"/"+poliza.CodProducto+"/"+poliza.RamCod;
            //:cliCod/:ciuCod/:TipoProceso/:TipoPoliza/:OrigenApp/:CodigoBien/:CodigoProducto/RamCod
            console.log(this.urlAsesor);
            break;
          case 2: //vivienda
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/2/1/"+poliza.CodVivienda+"/"+poliza.CodProducto+"/0";
              //:cliCod/:ciuCod/:TipoProceso/:TipoPoliza/:OrigenApp/:CodigoBien/:CodigoProducto
            break;
          case 3: //asistencia medica
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/3/1/" + poliza.CodAccPer + "/" + poliza.CodProducto;
            //:cliCod/:ciuCod/:TipoProceso/:TipoPoliza/:OrigenApp/:CodigoBien/:CodigoProducto
            break;
          case 4: //vida
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/3/1/" + poliza.CodAccPer + "/" + poliza.CodProducto;
            break;
          case 5: //otros ramos
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/4/1/" + poliza.CodProdGnral + "/" + poliza.CodProducto;
            break;
        }
        console.log("url Asesor",this.urlAsesor);
        this.banderaCita = true;
        this.modalAsesor.open();
      }
    );
  }

  CerrarModal() {
    this.banderaCita = false;
    this.urlAsesor = "";
  }
  IngresarReclamo(asistencia:AsistenciaMedicaEntity){
    this.vamReporteSiniestro = asistencia;
    this.cancelarBien = false;
    this.renovarVehiculo = false;
    this.renovarOtroRamo = false;
    this.renovarAsistencia = false;
    this.renovarvivienda = false;
    this.reporteVeh = false
    this.reporteViv = false;
    this.reporteVam=true;
  }

}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/segurosContratados/seguros-contratados.component.ts